import React, { memo, useEffect, useState } from "react";
import ConfettiExplosion from "react-confetti-explosion";
import CustomModal from "../../../layouts/Modal";
import Button from "../../../common/Button";
import lp from "../../../assets/icons/stayUsdc.png";
import image1 from "../../../assets/images/progress1_1.png";
import image2 from "../../../assets/images/progress1_2.png";
import image3 from "../../../assets/images/progress1_3.png";
import image4 from "../../../assets/images/progress1_4.png";
import { useNfstay } from "../../../context/ThemeContext";
import toast from "react-hot-toast";
import BLoader from "../../../common/BLoader";

const LPLiquidity = ({ isApprovedToken, maxBalance, inputVal, onHide, setInputVal }) => {
  const { approveToZapper, Farming_stakeLps } = useNfstay();
  const [isApproved, setIsApproved] = useState(false);
  const [isLoadingApproveLp, setIsLoadingApproveLp] = useState(false);
  const [isLoadingDeposit, setIsLoadingDeposit] = useState(false);
  const [isExploding, setIsExploding] = useState(false);
  const [status, setStatus] = useState({ isZap: false, isApproved: false, isDeposit: false });
  const [showLast, setShowLast] = React.useState(false);

  useEffect(() => {
    if (status.isApproved && status.isDeposit) {
      setIsExploding(true);
      setShowLast(true);
      setTimeout(() => {
        onHide();
      }, 2000);
    }
  }, [status]);

  useEffect(() => {
    setStatus(prev => ({ ...prev, isApproved: isApprovedToken }));
  }, []);

  const handleDeposit = async () => {
    try {
      setIsLoadingDeposit(true);
      await Farming_stakeLps(inputVal);
      toast.success("Transaction Successful");
      setInputVal("");
      await maxBalance("LP");
      status.isApproved && setStatus(prev => ({ ...prev, isDeposit: true }));
    } catch (e) {
      toast.error(e.reason || e.message || "Something went wrong");
    } finally {
      setIsLoadingDeposit(false);
    }
  };

  const approveLP = async asset => {
    try {
      setIsLoadingApproveLp(true);
      await approveToZapper(asset);
      setStatus(prev => ({ ...prev, isApproved: true }));
      setIsApproved(true);
    } catch (e) {
      console.log(e);
      toast.error(e.reason || e.message || "Something went wrong");
    } finally {
      setIsLoadingApproveLp(false);
    }
  };

  return (
    <CustomModal
      title="Stake To Earn"
      onHide={onHide}
    >
      {isExploding && (
        <div className="flex justify-center">
          <ConfettiExplosion
            particleCount={500}
            zIndex={999999}
          />
        </div>
      )}
      <div className="pl-4 relative">
        {!showLast ? (
          <img
            className="absolute -left-1 h-[193px] sm:h-[207px] top-[3px]"
            src={
              !status.isApproved && !status.isDeposit
                ? image1
                : status.isApproved && !status.isDeposit
                  ? image2
                  : status.isApproved && status.isDeposit
                    ? image3
                    : image4
            }
            alt="step"
          />
        ) : (
          <img
            className="absolute -left-1 h-[193px] sm:h-[207px] top-[3px]"
            src={image4}
            alt="step"
          />
        )}
        <div>
          <div className="flex justify-between items-center mb-2">
            <div>
              <p className="text-main font-bold">Approve LP Token</p>
            </div>
            <span className="max-sm:text-sm text-main opacity-70 font-medium">Step 1</span>
          </div>
          <Button
            className="w-full flex items-center gap-2 justify-center text-main"
            style={{
              color: !status.isApproved ? "#FFFFFF" : "var(--main)",
              background: !status.isApproved
                ? "var(--primary)"
                : `linear-gradient(90.57deg, rgba(153, 69, 255, 0.2) 0%, rgba(32, 225, 159, 0.2) 100%)`,
            }}
            onClick={() => approveLP("LP")}
            disabled={isLoadingApproveLp || isLoadingDeposit || status.isApproved}
          >
            {isLoadingApproveLp ? (
              <BLoader />
            ) : (
              <>
                {!status.isApproved ? (
                  <>
                    <img
                      src={lp}
                      alt="lp"
                    />
                    Approve LP Token
                  </>
                ) : (
                  "Approved"
                )}
              </>
            )}
          </Button>
        </div>

        <div className="mt-3">
          <div className="flex justify-between items-start mb-2">
            <div>
              <p className="text-main font-bold">Deposit LP Token</p>
            </div>
            <span className="max-sm:text-sm text-main opacity-70 font-medium">Step 2</span>
          </div>
          <Button
            className={`w-full flex items-center gap-2 justify-center border border-primary text-main`}
            style={{
              color: status.isApproved && !status.isDeposit ? "#FFFFFF" : "var(--main)",
              background:
                status.isApproved && !status.isDeposit
                  ? "var(--primary)"
                  : `linear-gradient(90.57deg, rgba(153, 69, 255, 0.2) 0%, rgba(32, 225, 159, 0.2) 100%)`,
            }}
            onClick={handleDeposit}
            disabled={
              isLoadingApproveLp || isLoadingDeposit || !status.isApproved || status.isDeposit
            }
          >
            {isLoadingDeposit ? (
              <BLoader />
            ) : (
              <>
                <img
                  src={lp}
                  alt="lp"
                />
                Deposit LP Token
              </>
            )}
          </Button>
        </div>
        <div className="mt-3">
          <div className="flex justify-between items-start mb-2">
            <div>
              <p className="text-main font-bold">Success</p>
            </div>
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default memo(LPLiquidity);
